module.exports = "https://activity.hdslb.com/blackboard/activity92636/img/fangyu-card-poster.a82985c3.png";